"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Title = _interopRequireDefault(require("../Title"));
var _textArea = _interopRequireDefault(require("./textArea.proptypes"));
var _constant = require("./constant");
var _excluded = ["children"];
var _inputWrapperVariants;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "TextArea__Wrapper",
  componentId: "sc-6fkm2k-0"
})(["display:flex;flex-direction:column;width:", ";height:", ";"], function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var height = _ref2.height;
  return height;
});
var inputWrapperVariants = (_inputWrapperVariants = {}, (0, _defineProperty2.default)(_inputWrapperVariants, _constant.INPUT_VARIANT.focused, (0, _styledComponents.css)(["background:", ";border-color:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.default;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.secondary;
})), (0, _defineProperty2.default)(_inputWrapperVariants, _constant.INPUT_VARIANT.error, (0, _styledComponents.css)(["border-color:", ";&:hover{border-color:", ";}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.orange;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.orange;
})), (0, _defineProperty2.default)(_inputWrapperVariants, _constant.INPUT_VARIANT.disabled, (0, _styledComponents.css)(["background-color:", ";&:hover{background:", ";border-color:", ";}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.greyLighter;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.greyLighter;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.greyLight;
})), _inputWrapperVariants);
var InputWrapper = _styledComponents.default.div.withConfig({
  displayName: "TextArea__InputWrapper",
  componentId: "sc-6fkm2k-1"
})(function (_ref10) {
  var variant = _ref10.variant;
  return (0, _styledComponents.css)(["position:relative;border:1px solid;box-sizing:border-box;border-radius:", ";border-color:", ";background-color:", ";padding:", ";display:flex;flex-direction:row;justify-content:center;align-items:center;&:hover{background:", ";border-color:", ";}", ""], function (_ref11) {
    var theme = _ref11.theme,
      borderRadius = _ref11.borderRadius;
    return borderRadius || theme.borderRadius.normal;
  }, function (_ref12) {
    var theme = _ref12.theme;
    return theme.colors.greyLight;
  }, function (_ref13) {
    var theme = _ref13.theme;
    return theme.colors.default;
  }, function (_ref14) {
    var theme = _ref14.theme;
    return "".concat(theme.space.micro, " ").concat(theme.space.XSmall);
  }, function (_ref15) {
    var theme = _ref15.theme;
    return theme.colors.default;
  }, function (_ref16) {
    var theme = _ref16.theme;
    return theme.colors.secondary;
  }, variant && inputWrapperVariants[variant]);
});
InputWrapper.displayName = 'InputWrapper';
var InputContent = _styledComponents.default.div.withConfig({
  displayName: "TextArea__InputContent",
  componentId: "sc-6fkm2k-2"
})(["display:flex;width:100%;height:", ";flex-direction:column;justify-content:flex-start;"], function (_ref17) {
  var height = _ref17.height;
  return height;
});
var StyledInput = _styledComponents.default.textarea.withConfig({
  displayName: "TextArea__StyledInput",
  componentId: "sc-6fkm2k-3"
})(["overflow:", ";resize:none;outline:none;border:none;line-height:inherit;height:100%;font-family:", ";font-size:", ";font-weight:", ";color:", ";margin-top:", ";&::placeholder{color:", ";opacity:0.5;}&:disabled{background-color:", ";}"], function (_ref18) {
  var overflow = _ref18.overflow;
  return overflow;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontFamily.default;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.fontSize.normal;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.fontWeight.bold;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.neutral;
}, function (_ref23) {
  var isActive = _ref23.isActive,
    theme = _ref23.theme;
  return !isActive ? theme.space.micro : 0;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.greyDark;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.colors.greyLighter;
});
StyledInput.displayName = 'StyledInput';
var SmallText = function SmallText(_ref26) {
  var children = _ref26.children,
    rest = (0, _objectWithoutProperties2.default)(_ref26, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    accessible: false,
    type: "small"
  }, rest), children);
};
SmallText.propTypes = {
  children: _propTypes.default.node.isRequired
};
var inputLabelVariants = {
  error: (0, _styledComponents.css)(["color:", ";"], function (_ref27) {
    var theme = _ref27.theme;
    return theme.colors.orange;
  })
};
var InputLabel = (0, _styledComponents.default)(SmallText).withConfig({
  displayName: "TextArea__InputLabel",
  componentId: "sc-6fkm2k-4"
})(function (_ref28) {
  var variant = _ref28.variant;
  return (0, _styledComponents.css)(["color:", ";line-height:", ";margin-bottom:", ";outline:none;", ""], function (_ref29) {
    var theme = _ref29.theme;
    return theme.colors.greyDark;
  }, function (_ref30) {
    var theme = _ref30.theme;
    return theme.lineHeight.XSmall;
  }, function (_ref31) {
    var theme = _ref31.theme;
    return theme.space.micro;
  }, variant && inputLabelVariants[variant]);
});
InputLabel.displayName = 'InputLabel';
var ErrorMessage = (0, _styledComponents.default)(SmallText).withConfig({
  displayName: "TextArea__ErrorMessage",
  componentId: "sc-6fkm2k-5"
})(["color:", ";"], function (_ref32) {
  var theme = _ref32.theme;
  return theme.colors.orange;
});
ErrorMessage.displayName = 'ErrorMessage';
var SpanWrapper = _styledComponents.default.span.withConfig({
  displayName: "TextArea__SpanWrapper",
  componentId: "sc-6fkm2k-6"
})(["margin-left:", ";color:", ";font-size:", ";"], function (_ref33) {
  var theme = _ref33.theme;
  return theme.space.micro;
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.colors.greyMedium;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.fontSize.small;
});
var TextArea = function TextArea(props) {
  var propValue = props.value,
    label = props.label,
    disabled = props.disabled,
    accessible = props.accessible,
    width = props.width,
    height = props.height,
    validateStatus = props.validateStatus,
    validateMessage = props.validateMessage,
    selectTextOnFocus = props.selectTextOnFocus,
    onChange = props.onChange,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    theme = props.theme,
    customProperties = props.customProperties,
    className = props.className,
    placeholder = props.placeholder,
    alwaysShowLabel = props.alwaysShowLabel,
    overflow = props.overflow,
    title = props.title,
    subtitle = props.subtitle,
    spanText = props.spanText,
    borderRadius = props.borderRadius;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var _useState = (0, _react.useState)(propValue),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  (0, _react.useEffect)(function () {
    setValue(propValue);
  }, [propValue]);
  var handleTextChange = function handleTextChange(event) {
    var newValue = event.target.value;
    setValue(newValue);
    onChange(event);
  };
  var handelFocus = function handelFocus(event) {
    if (selectTextOnFocus) {
      event.target.select();
    }
    setFocused(true);
    onFocus(event);
  };
  var handleBlur = function handleBlur(event) {
    setFocused(false);
    onBlur(event);
  };
  var inputProps = _objectSpread({
    value: value,
    disabled: disabled,
    placeholder: placeholder || (focused ? '' : label),
    label: label,
    tabIndex: tabIndex,
    className: className,
    onFocus: handelFocus,
    onBlur: handleBlur,
    onChange: handleTextChange
  }, customProperties);
  var isActive = alwaysShowLabel || focused || value;
  var variant = '';
  if (disabled) {
    variant = _constant.INPUT_VARIANT.disabled;
  } else if (focused && validateStatus === _constant.VALIDATE_STATUS_ERROR) {
    variant = _constant.INPUT_VARIANT.error;
  } else if (focused) {
    variant = _constant.INPUT_VARIANT.focused;
  } else if (validateStatus) {
    variant = validateStatus;
  }
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(Wrapper, {
      width: width
    }, title && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Title.default, {
      type: "h3",
      marginBottom: "small",
      theme: theme,
      accessible: accessible
    }, title, spanText && /*#__PURE__*/_react.default.createElement(SpanWrapper, null, spanText))), subtitle && /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: "greyDarker",
      marginBottom: "tiny",
      theme: theme,
      accessible: accessible
    }, subtitle), /*#__PURE__*/_react.default.createElement(InputWrapper, {
      borderRadius: borderRadius,
      variant: variant
    }, /*#__PURE__*/_react.default.createElement(InputContent, {
      height: height
    }, isActive && /*#__PURE__*/_react.default.createElement(InputLabel, {
      variant: validateStatus
    }, isActive && label), /*#__PURE__*/_react.default.createElement(StyledInput, (0, _extends2.default)({
      isActive: isActive,
      overflow: overflow
    }, inputProps)))), validateStatus === _constant.VALIDATE_STATUS_ERROR && validateMessage && /*#__PURE__*/_react.default.createElement(ErrorMessage, {
      accessible: false
    }, validateMessage));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
TextArea.propTypes = _textArea.default.PropTypes;
TextArea.defaultProps = _textArea.default.DefaultProps;
TextArea.displayName = 'TextArea';
var _default = TextArea;
exports.default = _default;